import React , { useState , useEffect , useRef } from "react";
import ChoosFoodCart from "./ChoosFoodCart";
import KindFoodNav from "./KindFoodNav";
import { burger } from "../assetss/data/food/burger";
import { pizza } from "../assetss/data/food/pizza";
import { sandwich } from "../assetss/data/food/sandwich";
import { fried } from "../assetss/data/food/fried";
import { before } from "../assetss/data/food/before";
import { pasta } from "../assetss/data/food/pasta";
import { useInView } from "react-intersection-observer";

const ChooseFoodPart = ({qty , setQty ,onAdd , increase , decrease}) => {
  const [active, setActive] = useState(null);
  // const [active, setActive] = useState(false);
  const storedId = localStorage.getItem("visible");
  
    useEffect(() => {
      console.log(storedId);
      
    }, [storedId]);
   

  return (
    <div>
      <KindFoodNav storedId={storedId}  active={active} setActive={setActive} />
      <ChoosFoodCart setActive={setActive} title="برگر" idName="burgur" kinds={burger} />
      <ChoosFoodCart setActive={setActive} title="پیتزا" idName="pizza" kinds={pizza} />
      <ChoosFoodCart setActive={setActive} title="ساندویچ" idName="sandwich" kinds={sandwich} />
      <ChoosFoodCart setActive={setActive} title="سوخاری" idName="fried" kinds={fried} />
      <ChoosFoodCart setActive={setActive} title="پاستا" idName="pasta" kinds={pasta} />
      <ChoosFoodCart setActive={setActive} title="پیش غذا" idName="before" kinds={before} />
    </div>
  );
};

export default ChooseFoodPart;
